<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="activate(row.data.item)"
                  class="px-2"
                >
                  <v-icon v-if="!row.data.item.IsActive" color="red"
                    >mdi-folder-lock</v-icon
                  >
                  <v-icon v-if="row.data.item.IsActive" color="green"
                    >mdi-folder-lock-open</v-icon
                  >
                </a>
              </template>
              <span>
                {{ row.data.item.IsActive ? $t("Deactivate") : $t("Activate") }}
              </span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
    <BasketModal :ref="modalKey" @on-item-saved="onItemSaved" />
  </div>
</template>

<script>
import BasketService from "@/services/BasketService";
import BasketModal from "@/components/administration/basket/BasketModal.vue";
import Utils from "@/ecm/common/Utils";

export default {
  components: {
    BasketModal,
  },

  data() {
    return {
      title: this.$t("Baskets"),
      grid: {
        key: "basketGrid",
        dataSource: BasketService.getGrid(),
        columns: [
          {
            field: "Name",
            caption: this.$t("Name"),
            type: "string",
          },
          {
            field: "RoleTypesNames",
            caption: this.$t("Roles"),
            type: "string",
          },
        ],
      },
      modalKey: "modalBasket",
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    editItem(dto) {
      this.modalInstance.edit(dto);
    },
    activate(dto) {
      BasketService.activate(dto.Id).then((result) => {
        this.gridInstance.refresh();
      });
    },
    deleteItem(dto) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          BasketService.delete(dto.Id).then((result) => {
            if (result) {
              this.gridInstance.refresh();
              Utils.toast.success(this.$t("Basket") + " "+ this.$t("DeletedSuccessfullyFem"));
            }
          });
        }
      });
    },
    add() {
      this.modalInstance.new();
    },
    onItemSaved() {
      this.gridInstance.refresh();
    },
  },
};
</script>